import $ from 'jquery';
import 'slick-carousel';
import FCM from './fcm';
import Donations from './donations';
import Smsmemo from './smsmemo';


const Site = new (function () {
    const top_menu = function () {
        const menu = $('#menu');
        const toggle = menu.find('.nav-toggle');

        toggle.on('click', () => menu.toggleClass('open'));
    };

    const logo_scroll = function () {
        const $window = $(window);
        const logo = $('#menu').find('.logo');

        $window.on('scroll', function () {
            const window_top_position = $window.scrollTop();

            if (window_top_position > 16) {
                if (!logo.hasClass('small')) {
                    logo.addClass('small');
                }
            } else {
                logo.removeClass('small');
            }
        });

        $window.trigger('scroll');
    };

    const home_children_slider = function () {
        $('#children').slick({
            arrows: false,
            dots: true,
            //infinite: false,
            //speed: 300,
            slidesToShow: 5,
            slidesToScroll: 5,
            swipeToSlide: true,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }]
        });
    };

    const disable_copying_from_page = function () {
        const disable_context_menu = false;
        const except_locations = ['/ru/page/donate', '/en/page/donate'];

        // body has user-select: none, make an exception for the following URLs
        if (except_locations.indexOf(window.location.pathname) > -1) {
            $('body').addClass('nonoselect');
            return;
        }

        if (disable_context_menu) {
            $(document).on('mousedown', function (event) {
                if (event.button == 2) {
                    return false;
                }
            });

            $('body').on('contextmenu', function () {
                return false;
            });
        }
    };

    const widgets = function () {
        const vk_groups = $('#vk_groups');
        if (vk_groups.length) {
            VK.Widgets.Group("vk_groups", {mode: 0, width: "200", height: "290"}, 22163444);
        }

        pennybank.widget('pb-widget-200x75', 200, 300);        
    };

    this.main = function () {
        disable_copying_from_page();
        top_menu();
        logo_scroll();
        home_children_slider();

        $('body').removeClass('notransition');

        FCM.main();
        Donations.main();
        widgets();
        Smsmemo.main();
    };
})();

export default Site;



// WEBPACK FOOTER //
// ./site/js/index.js